<template>
  <v-form>
    <v-container>
      <v-layout row wrap>

        <!-- 1라인 -->
        <v-flex xs12 sm12 md6>
          <v-text-field
            label="제목"
            solo
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field
            label="시작시간"
            solo
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field
            label="종료시간"
            solo
          ></v-text-field>
        </v-flex>

        <!-- 2라인 -->
        <v-flex xs12 sm12 md6>
          <v-text-field
            label="회의실"
            solo
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md6>
          <v-text-field
            label="참가대상"
            solo
          ></v-text-field>
        </v-flex>

        <!-- 3라인 -->
        <v-flex xs12 sm12 md6>
          <v-text-field
            label="회의실"
            solo
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md6>
          <v-text-field
            label="비밀번호"
            solo
          ></v-text-field>
        </v-flex>

      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import MeetingInfoDialog from '@/components/popup/MeetingInfoDialog';

export default {
  components: {
    MeetingInfoDialog
  },
  props: [
    'meeting',
    'host'
  ],
  data: () => ({
    addDialog: false,
    editDialog: false,
    removeDialog: false,
    search: '',
    listData: [
      {
        time: '2019.09.27 09:00~10:00',
        title: '업무 회의 진행중',
        info: '주최자 : 하준호 파트너 / 참여자 : 전빈 외3명 / 장소 : Lounge A',
        status: 's',
      },
      {
        time: '2019.09.27 10:00~11:00',
        title: '업무 회의 예약중',
        info: '주최자 : 하준호 파트너 / 참여자 : 전빈 외3명 / 장소 : Lounge A',
        status: 'r',
      },
    ],
    searchData: [],
    dataPerPage: 3,
    curPageNum: 1,
    curSelectIndex: 0,

    newData: {
      time: '',
      title: '',
      info: ''
    },
    selectedData: {
      time: '',
      title: '',
      info: ''
    },
    meetingInfoDialog: {
      dialog: false,
    },
  }),
  computed: {
    startOffset () {
      return ((this.curPageNum - 1) * this.dataPerPage);
    },
    endOffset () {
      return (this.startOffset + this.dataPerPage);
    },
    numOfPages () {
      let numPages = Math.ceil(this.searchData.length / this.dataPerPage);
      return numPages === 0 ? 1 : numPages;
    },
    calListData () {
      // this.listData = this.meeting;
      return this.listData;
    },
    calData () {
      this.searchData = this.calListData.filter((data) => {
        return data.title.toLowerCase().includes(this.search.toLowerCase());
      }).slice(0);

      return this.searchData.slice(this.startOffset, this.endOffset);
    }
  },
  created () {
    // this.listData = this.meeting;
    this.curPageNum = 1;
    // this.axios.get('http://localhost:8080/server/listTest.json')
    //   .then((response) => {
    //     this.listData = response.data;
    //     console.log(this.listData);
    //   });
  },
  methods: {
    submit () {
      const submitData = {
        id: this.newData.id,
        subject: this.newData.subject,
        desc: this.newData.desc
      };
      /*
      Ajax 통신 후
        */
      this.addData(submitData);
      this.closeDialog();
      this.clearForm();
    },
    editData () {
      const editData = {
        time: this.selectedData.time,
        title: this.selectedData.title,
        info: this.selectedData.info
      };
      /*
      Ajax 통신 후
        */
      this.calListData.splice(this.curSelectIndex, 1, editData);
      this.closeDialog();
    },
    addData (submitData) {
      this.calListData.push(submitData);
      this.curPageNum = this.numOfPages;
    },
    removeData () {
      this.calListData.splice(this.curSelectIndex, 1);
      if (this.calData.length === 0) {
        this.prevPage();
      }
      this.closeDialog();
    },
    onAdd () {
      this.addDialog = true;
    },
    onRemove (index) {
      this.curSelectIndex = this.calIndex(index);

      this.removeDialog = true;
    },
    onEdit (index) {
      this.curSelectIndex = this.calIndex(index);      
      this.selectedData.time = this.calListData[this.curSelectIndex].time;
      this.selectedData.title = this.calListData[this.curSelectIndex].title;
      this.selectedData.info = this.calListData[this.curSelectIndex].info;

      this.editDialog = true;
    },
    onInfo (index) {
      this.meetingInfoDialog.dialog = true;
    },
    calIndex (index) {
      switch (this.curPageNum) {
        case 1:
          return index;
        default:
          return index + ((this.curPageNum - 1) * this.dataPerPage);
      }
    },
    clearForm () {
      // for (let key in this.newData) {
      //   this.newData[key] = '';
      // }
    },
    prevPage () {
      this.curPageNum--;
    },
    closeDialog () {
      this.addDialog = false;
      this.editDialog = false;
      this.removeDialog = false;
    },
    meetingInfoItem (item) {
      this.meetingInfoDialog.dialog = true;
    },

    closeMeetingInfoDialog (type) {
      this.meetingInfoDialog.dialog = false;
    },
  },

};
</script>
<style scoped lang="stylus">

</style>


// WEBPACK FOOTER //
// src/components/meeting/MeetingCreate.vue